@if (editBetState$ | async; as editBetState) {
    <bs-digital-pick-list>
        @if (oddsDisplayFormat$ | async; as oddsDisplayFormat) {
            @for (pick of editBetState.addPicksState.pickList; track pickTrackBy($index, pick)) {
                <bs-edit-bet-add-pick
                    class="betslip-edit-bet__picks-item {{ getPickStateClass(pick) }}"
                    [pick]="pick"
                    [oddsDisplayFormat]="oddsDisplayFormat"
                    [msAutomation]="pick.id.toString()" />
            }
        }
    </bs-digital-pick-list>
}
